// extracted by mini-css-extract-plugin
module.exports = {"svg-hover":"DayCircle_svg-hover__3874W","selected-circle-inner":"DayCircle_selected-circle-inner__2yxG4","hovered-circle":"DayCircle_hovered-circle__2pmE9"};